<template>
  <div class="qr-code-google">
    <ImageElement
      aria-hidden="true"
      render-without-figure
      lazy
      src="/content/content-images/dcb/e6e751794d352566d8f26b07f0eb4c7e/google-qr.svg"
      class="qr-code-google__code"
    />
    <br />
    <LinkButton
      tag="a"
      text
      target="_blank"
      is-external
      :to="googlePlay"
    >
      Für Android/Google
    </LinkButton>
  </div>
</template>

<script setup lang="ts">
import { ImageElement, LinkButton } from '@i22team/td-longtail-vue-components';
import { googlePlay } from './qr-code-links';
</script>

<style lang="scss" scoped>
.qr-code-google {
  &__code {
    background: white;
    width: 120px;
  }
}
</style>
